// extracted by mini-css-extract-plugin
module.exports = {"container":"Adhesion_container__6zhWB"};